import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IAddress } from 'libraries/hotel/models/address';
import { faMapMarker, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'address-component',
    template: `
        <div class="complementary">
            <ng-container *ngIf="property?.textLines?.length; else noTextLines">
                <fa-icon [icon]="iconMapMarker" class="icon"></fa-icon>
                <address class="address">
                    <ng-container *ngFor="let addressLine of property.textLines; let last = last;">
                        {{ addressLine }}
                        <br *ngIf="!last && !displayInline"/>
                        <ng-container *ngIf="!last && displayInline">-</ng-container>
                    </ng-container>
                </address>
            </ng-container>
            <ng-template #noTextLines>
                <ng-container *ngIf="addressLines">
                    <fa-icon [icon]="iconMapMarker" class="icon"></fa-icon>
                    <address class="address">
                        <ng-container *ngIf="displayInline">
                            {{addressLinesString}}
                        </ng-container>
                        <ng-container *ngIf="!displayInline">
                            <div *ngFor="let line of addressLines">{{line}}</div>
                        </ng-container>
                    </address>
                </ng-container>
            </ng-template>
        </div>
    `,
    styles: [
        `
            .complementary {
                display: flex;
                flex-wrap: nowrap;
            }

            :host {
                font-style: normal;
            }

            .icon {
                display: inline-block;
                text-align: center;
                vertical-align: top;
                width: 18px;
            }

            .address {
                display: inline-block;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressComponent implements OnChanges {

    @Input()
    public property: IAddress;

    @Input()
    public displayInline: boolean = false;

    public addressLines: string[] = [];
    public addressLinesString: string;

    public iconMapMarker: IconDefinition = faMapMarker;

    public ngOnChanges(): void {
        this.formatAddress();
    }

    public formatAddress(): void {
        if (this.property) {
            const street: string = this.property.street ? this.property.street : (this.property.streetLines || []).join(' - ');
            const country: string = this.property.country ? this.getCountry() : null;
            const city: string = this.property.city ? this.getCity() : null;
            const state: string = typeof this.property.state === 'string' ? this.property.state as string : (this.property.state as {code: string})?.code ?? null;
            const zipcode: string = this.property.zipcode;
            this.addressLines = [street, country, city, state, zipcode];
            this.addressLinesString = this.addressLines.join(' - ');
        }
    }

    private getCity(): string {
       return this.property.city.name ? (this.property.city.name as { value: string }).value ?? this.property.city.name as string : this.property.city as unknown as string;
    }

    private getCountry(): string {
        return this.property.country.name ? this.property.country.name : this.property.country.iso ?? this.property.country as string;
    }


}
